import React from 'react';
import Link from '../Link';
import Spinner from '../Spinner';
import Tooltip from '../Tooltip';
import style from './style.module.css';

export default class Button extends React.Component {
    render() {
        const { icon = "", display = true, disabledTip = false, className = false, submit = false, label = "", fetching = false, link = "", disabled = false, onClick = () => { }, target = "_self", download = false, buttonType = "button", id = null } = this.props;
        let btnClass = `${style.button} ${this.getSizeClass()} ${this.getColorClass()}${className !== false ? " " + className : ""}`;
        if (display === false) {
            return null;
        }

        if (fetching === true) {
            return (
                <div className={btnClass}>
                    <div className={style.fetching}>
                        <Spinner color={this.getSpinnerColor()} />
                    </div>
                    <span>&nbsp;</span>
                </div>
            )
        }

        if (disabled === true) {
            return (
                <div className={`${btnClass} ${style.buttonDisabled}`}>
                    <div className={`${btnClass}`}>
                        {
                            icon && (
                                <span className={style.btnIcon}><i className={icon}></i></span>
                            )
                        }
                        <span>{label}</span>
                        {
                            disabledTip !== false && (
                                <span className={style.buttonQuestion}>
                                    <i className='fa-solid fa-circle-question'></i>
                                </span>
                            )
                        }
                    </div>
                    {
                        disabledTip !== false && (
                            <Tooltip {...this.props}>{disabledTip}</Tooltip>
                        )
                    }
                </div>
            )
        }

        if (submit === true) {
            return (
                <button id={id} type="submit" className={`${btnClass}`} onClick={onClick} >
                    <span>
                        {icon && (
                            <span className={style.btnIcon}><i className={icon}></i></span>
                        )}
                        <span>{label}</span>
                    </span>
                </button>
            )
        }

        return (
            <Link to={link} id={id} className={`${style.button} ${btnClass} ${icon ? style.btnWithYes : ''}`} onClick={onClick} target={target} download={download} buttonType={buttonType}>
                {icon && (
                    icon
                )}
                <span dangerouslySetInnerHTML={{ __html: label }}></span>
            </Link>
        )
    }

    getSizeClass = () => {
        const { size } = this.props;
        if (size === "buttonBig"){
            return style.buttonBig;
        }
        if (size === "buttonFullWidth"){
            return style.buttonFullWidth;
        }
        if (size === "buttonSmall"){
            return style.buttonSmall;
        }
    }

    getColorClass = () => {
        const { color } = this.props;
        if (color === "buttonPrimary") {
            return style.buttonPrimary;
        }
        if (color === "buttonPrimaryWithOutBg") {
            return style.buttonPrimaryWithOutBg;
        }
        if (color === "buttonDefaultWithOutBg") {
            return style.buttonDefaultWithOutBg;
        }
        if (color === "buttonSecondary") {
            return style.buttonSecondary;
        }
        if (color === "buttonSecondaryWithBg") {
            return style.buttonSecondaryWithBg;
        }
        return style.buttonDefault;
    }

    getSpinnerColor = () => {
        const { color } = this.props;
        if (color === "green") {
            return "#02269E";
        }
        if (color === "opaqueBlack") {
            return "#000";
        }
        if (color === "opaqueRed") {
            return "#bd2424";
        }
        if (color === "variableReverse") {
            return "var(--btn-variable)";
        }
        return "#fff";
    }
}